import { SubMenuItem } from "Shared/Types/sidebar";

export function isRouteActive(
  pathname: string,
  url: string,
  subMenu?: SubMenuItem[]
): boolean {
  const getRootSegment = (path: string): string => {
    return `/${path.split("/").filter(Boolean)[0]}`;
  };

  const currentRootLocation = getRootSegment(pathname);
  const rootLocation = getRootSegment(url);

  return (
    rootLocation === currentRootLocation ||
    pathname === url ||
    currentRootLocation === url ||
    (subMenu?.some(
      (item) => currentRootLocation === item.url || item.url === pathname
    ) ??
      false)
  );
}
